/**
 * Created by amirb on 1/29/15.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseCategoriesWidget = require('web-agent-widgets/BaseCategoriesWidget');
    var widgetConfig = require('web-agent-widgets/widgetConfig');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var VisitInfoBase = BaseCategoriesWidget.extend({
        ControllerName: "VisitInfoBase",
        applicationType: "VisitInfoBase",

        LPViewMap: {
        },

        widgetIcon: "right_pane_suitcase",

        LPPrefixMap: {
            visitInfo: "VISIT_INFO",
            openState: "opened"
        },

        LPInfoLineType : {
            INFO : "type1",
            INFO_ICON : "type1 icon",
            ORDER : "type2",
            ORDER_TITLE : "type2 title",
            LINK : "type1 link",
            NO_TITLE : "type1 notitle",
            NO_TITLE_WIDE : "type1 notitle wide"
        },

        initialize: function () {
            this.tableName = this.configuration.tableName;
            this.toggleRowsState = {};
            if (this.tableName !== "ConnectionsLogTableViewController" && this.tableName !== "EngagementsHistoryTableViewController") {
                this.setState(this.LPStateMap.fetching);
            }
        },

        events: function () {
            if (this.singleton && this.tableName) {
                this.viewEventsHandler.bindEvent({appName : this.tableName , UIEvent : this.viewEventsHandler.eventType.TABLE_WIDGETS_OPENED, callback: this.onSelectedVisitorChanged});
                this.viewEventsHandler.bindEvent({appName : this.tableName , UIEvent : this.viewEventsHandler.eventType.TABLE_WIDGETS_CLOSED, callback: this.handleWidgetsClosed, context: this});
            } else {
                this.bindToModel();
            }
        },

        render: function () {
        }
    });

    VisitInfoBase.prototype.bindToModel = function () {
        if(this.visitorId) {
            this.bindModel({modelPath : this.getRootModelPath(), callback: this.handleVisitInfoChanged});
            this.bindModel({ modelPath: this.configuration.engagementInfoModelPath + "." + this.visitorId + ".participantTag", callback: this.participantTagChanged });
            this.bindModel({ modelPath: lpTag.WebAgent.logicController.getParticipantDataPath(this.visitorId) + '.state', callback: this.handleParticipantFetchStateChanged});
        }
    };

    VisitInfoBase.prototype.getConfiguration = function () {
        var configuration = {
            textPrefix: this.LPPrefixMap.visitInfo,
            rowTemplateFile: "LP_visit_info_row.html",
            dataRenderer: this.dataRenderer,
            rootModelPath: this.rootModelPath || "participants.info",
            engagementInfoModelPath: "participants.myEngagements",
            widgetDataConfig: this.widgetDataConfig(),
            context: this
        };
        return configuration;
    };
    VisitInfoBase.prototype.widgetDataConfig = function () {
        return widgetConfig.getInstance().getWidgetConfig("visitInfo");
    };

    VisitInfoBase.prototype.getRootModelPath = function () {
        var path = this.configuration.rootModelPath + '.' + this.visitorId;
        if (this.configuration.useDataInPath) {
            path += '.data';
        }
        return path;
    };

    VisitInfoBase.prototype.handleErrorState = function () {
        if (this.categoriesTable && this.categoriesTable.modelData && this.categoriesTable.modelData.length) {
            //handle the case that we get error state from the server but we still have data in the model
            this.setState('partial');
            this.unbindViewEvent({selector: this.LPViewMap.refreshAction, DOMEvent: "click", callback: this.refreshClicked});
        } else {
            lpTag.WebAgent.visitorInfoController.stopPollingVisitorInfo(this.configuration.visitorId, true);

        }
    };

    VisitInfoBase.prototype.getEngagementInfoModelPath = function () {
        return this.configuration.engagementInfoModelPath + "." + this.visitorId + ".participantInfo";
    };

    VisitInfoBase.prototype.onSelectedVisitorChanged = function (data) {
        if (!data.newValue || !data.newValue.eventData) {
            return;
        }

        if (!this.configuration || !this.configuration.itemIdTag) {
            return;
        }
        var newVisitorId = lpUtils.getPropertyValueByPath(data.newValue.eventData, this.configuration.itemIdTag);
        if(!newVisitorId) {
            return;
        }
        if (this.visitorId && this.visitorId !== newVisitorId) {
            this.unbindModel({modelPath :  this.getRootModelPath(), callback: this.handleVisitInfoChanged});
        }
        BaseCategoriesWidget.prototype.onSelectedVisitorChanged.call(this, newVisitorId);
        this.bindModel({modelPath :  this.getRootModelPath(), callback: this.handleVisitInfoChanged});
    };

    VisitInfoBase.prototype.handleWidgetsClosed = function () {
        BaseCategoriesWidget.prototype.unbindEvents.call(this);
    };

    VisitInfoBase.prototype.handleVisitInfoChanged = function (data) {
        if (data.newValue && data.key) {
            var visitInfoData = this.preprocessingHandleVisit(data);
            var dataToRender = widgetConfig.getInstance().generateWidgetData(this.widgetDataConfig, visitInfoData);
            if (this.showOrHideWidget) {
                this.showOrHideWidget(dataToRender.sections);
            }
            this.updateModelData(dataToRender.sections);
        }
    };

    VisitInfoBase.prototype.handleParticipantFetchStateChanged = function (data) {
        if (data && data.newValue) {
            var fetchState = data.newValue;
            if (this.LPStateMap[fetchState]) {
                this.setState(this.LPStateMap[fetchState]);
            }
        }
    };

    VisitInfoBase.prototype.preprocessingHandleVisit = function () {
        return lpUtils.cloneObject(this.getModelParam(this.getRootModelPath()));
    };

    VisitInfoBase.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return data.length;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data[sectionIndex].rows.length;
        },
        dataForSection: function (data, sectionIndex) {
            var value = {};
            if (BaseCategoriesWidget.prototype.dataRenderer && BaseCategoriesWidget.prototype.dataRenderer.dataForSection) {
                value = BaseCategoriesWidget.prototype.dataRenderer.dataForSection.call(this, data, sectionIndex);
            }
            value.title = data[sectionIndex].display.title;
            return value;
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[sectionIndex].rows[rowIndex].display;
            return this.getDataToRender(rowData);
        },

        filterRow: function (data, filterText) {
            return this.categoriesTable.shouldFilterRow(data, filterText, ["title", "value", "titlePrefix", "description", "descriptionPrefix", "descriptionSuffix", "device", "message", "code", "contextId", "level", "resolved"]);
        },

        getPropertiesForHighlight: function () {
            return {
                labelTitle: true,
                labelDetails: true,
                value: true
            };
        }
    };

    VisitInfoBase.prototype.getDataToRender = function (rowData) {
        if (rowData && rowData.type && this.renderMethods[rowData.type]) {
            return this.renderMethods[rowData.type].call(this, rowData);
        }
    };

    VisitInfoBase.prototype.multipleValuesInRow = function (rowDataArr, rowId) {
        var valueArrayValues = '',
            textInjection,
            arrayValuesTemplate = require('web-agent-templates/LP_visit_info_row_array_value.html');
            // arrayValuesTemplate = lpUtils.loadResource('web-agent-templates/LP_visit_info_row_array_value.html');
        for (var i = 0; i < rowDataArr.length; i++) {
            textInjection = {
                arrayValue: rowDataArr[i]
            };
            valueArrayValues += this.injectTextDefaults(arrayValuesTemplate, textInjection);
            if (i !== rowDataArr.length - 1) {
                valueArrayValues += ',<br>';
            }
        }

        var expandedRowState = (typeof rowId !== "undefined" && typeof this.toggleRowsState[rowId] !== "undefined" && this.toggleRowsState[rowId] === true) ? this.LPPrefixMap.openState : "";
        arrayValuesTemplate = require('web-agent-templates/LP_visit_info_row_array_values.html');
        // arrayValuesTemplate = lpUtils.loadResource('web-agent-templates/LP_visit_info_row_array_values.html');
        textInjection = {
            firstValue: rowDataArr[0],
            arrayValues: valueArrayValues,
            unshownValuesCount: rowDataArr.length - 1,
            expandedState: expandedRowState
        };
        return this.injectTextDefaults(arrayValuesTemplate, textInjection);
    };

    VisitInfoBase.prototype.renderMethods = {
        info : function (rowData) {
            if(_.isNull(rowData.value) || _.isUndefined(rowData.value)) {
                return;
            }var dataToRender = this.getDefaultRowObject(rowData);
            dataToRender.type = this.LPInfoLineType.INFO;
            dataToRender.labelTitle = rowData.title;
            dataToRender.labelTitleTooltip = rowData.titleTooltip || dataToRender.labelTitle;
            dataToRender.value = WebAgentUtils.sanitizeText(rowData.value).text;
            dataToRender.valueTooltip = rowData.valueTooltip || dataToRender.value;
            if(rowData.value && rowData.value.constructor === Array && rowData.value.length > 1 ) {
                dataToRender.arrayValue = this.multipleValuesInRow(rowData.value, rowData.id);
                dataToRender.value = '';
            }
            return dataToRender;
        },
        auth : function (rowData) {
            var value = rowData.value;
            if(typeof value === 'string' && value.indexOf('lp_ref:') === 0){
                value = "**************";
            }
            var dataToRender = this.renderMethods.icon.call(this, {
                rowData: rowData,
                title: rowData.title,
                value: value,
                valueTooltip: (rowData.valueTooltip || value) + this.translate('VERIFIED_DATA_TOOLTIP_SUFFIX'),
                iconType: 'auth',
                iconState: ''
            });
            if(rowData.value && rowData.value.constructor === Array && rowData.value.length > 1 ) {
                dataToRender.arrayValue = this.multipleValuesInRow(rowData.value, rowData.id);
                dataToRender.value = '';
            }
            return dataToRender;
        },
        title : function (rowData) {
            var dataToRender = this.getDefaultRowObject(rowData);
            dataToRender.type = this.LPInfoLineType.ORDER_TITLE;
            if (rowData.title) {
                dataToRender.labelTitle = rowData.titlePrefix ? rowData.titlePrefix + ": " : "";
                dataToRender.labelTitle += rowData.title;
            }
            dataToRender.labelTitleTooltip = dataToRender.labelTitle;
            dataToRender.value = WebAgentUtils.sanitizeText(rowData.value || "").text;
            dataToRender.valueTooltip = rowData.valueTooltip || dataToRender.value;
            return dataToRender;
        },
        country : function (rowData) {
            var value = rowData.geoState ? rowData.geoState + ', ' : '';
            value += rowData.country;
            return this.renderMethods.icon.call(this, {
                rowData: rowData,
                title: rowData.title,
                value: value,
                iconType: 'flag',
                iconState: 'flag-' + (rowData.countryCode ? rowData.countryCode.toLowerCase(): '')
            });
        },
        device : function (rowData) {
            if(_.isString(rowData && rowData.device)){
                var textKey = 'VISIT_INFO_Device_' + rowData.device.toUpperCase();
                return this.renderMethods.icon.call(this, {
                    rowData: rowData,
                    title: rowData.title,
                    value: this.isTranslated(textKey) ? this.translate(textKey) : rowData.device,
                    iconType: 'device',
                    iconState: 'device-' + (rowData.device.toLowerCase())
                });
            }
        },
        source : function (rowData) {
            if (rowData.value) {
                var renderMethod = rowData.value.type !== "unknown" ? "icon" : "info";
                return this.renderMethods[renderMethod].call(this, {
                    rowData: rowData,
                    title: rowData.title,
                    value: rowData.value.title,
                    valueTooltip: rowData.value.tooltip,
                    iconType: rowData.value.type,
                    iconState: rowData.value.value && rowData.value.value.toLowerCase()
                });
            }
        },
        isResolved : function (rowData) {
            var textKey = 'isConversationResolvedText_' + rowData.isResolved;
            var tooltipKey = 'isConversationResolvedTooltip_' + rowData.isResolved;
            return this.renderMethods.icon.call(this, {
                rowData: rowData,
                title: rowData.title,
                value: this.isTranslated(textKey) ? this.translate(textKey) : rowData.isResolved,
                valueTooltip: this.isTranslated(tooltipKey) ? this.translate(tooltipKey) : rowData.isResolved,
                iconType: 'icon_resolved',
                iconState: rowData.isResolved
            });
        },

        CSATStar: function (rowData) {
            var dataToRender = this.getDefaultRowObject(rowData);
            var value = rowData.value ? rowData.value + "/5" : "";
            if (value) {
                return this.renderMethods.icon.call(this, {
                    rowData: rowData,
                    title: rowData.title,
                    value: value,
                    valueTooltip: rowData.valueTooltip || dataToRender.value,
                    iconType: 'icon_star'
                });
            }
        },

    unescapedInfo: function (rowData) {
        var dataToRender = this.getDefaultRowObject(rowData);
        dataToRender.type = this.LPInfoLineType.INFO;
        dataToRender.labelTitle = rowData.title;
        dataToRender.labelTitleTooltip = dataToRender.labelTitle;
        dataToRender.unescapedValue = WebAgentUtils.sanitizeText(rowData.value).text.replace(/(?:\r\n|\r|\n)/g,'<br>');
        dataToRender.unescapedTooltip = WebAgentUtils.sanitizeText(rowData.value).text.replace(/(?:\r\n|\r|\n)/g,'&#013');
        return dataToRender;
    },
    descriptionInfo : function (rowData) {
        if(_.isNull(rowData.value) || _.isUndefined(rowData.value)) {
            return;
        }var dataToRender = this.getDefaultRowObject(rowData);
        dataToRender.type = this.LPInfoLineType.ORDER;
        dataToRender.labelTitle = rowData.title;
        dataToRender.labelTitleTooltip = rowData.titleTooltip || dataToRender.labelTitle;
        dataToRender.value = WebAgentUtils.sanitizeText(rowData.value).text;
        dataToRender.valueTooltip = rowData.valueTooltip || dataToRender.value;
        if (rowData.description || rowData.descriptionSuffix) { // we will render the description line only if we get at least the one of those two values
            dataToRender.labelDetails = rowData.descriptionPrefix && rowData.description ? rowData.descriptionPrefix + ": " : "";
            dataToRender.labelDetails += rowData.description || "";
            dataToRender.labelDetails += rowData.descriptionSuffix && rowData.description ? ", " : "";
            dataToRender.labelDetails += rowData.descriptionSuffix ? rowData.descriptionSuffix : "";
            dataToRender.labelDetailsTooltip = dataToRender.labelDetails;
        }
        if (rowData.extraDescription) {
            dataToRender.labelExtraDetails = rowData.extraDescriptionPrefix && rowData.extraDescription ? rowData.extraDescriptionPrefix + ": " : "";
            dataToRender.labelExtraDetails += rowData.extraDescription || "";
            dataToRender.labelExtraDetailsTooltip = dataToRender.labelExtraDetails;
        }
        return dataToRender;
    },
    link : function (rowData) {
        var dataToRender = this.getDefaultRowObject(rowData);
        dataToRender.type = this.LPInfoLineType.LINK;
        dataToRender.labelTitle = rowData.title;
        dataToRender.labelTitleTooltip = dataToRender.labelTitle;
        var linkTemplate = require("web-agent-templates/LP_visit_info_row_link.html");
            // var linkTemplate =lpUtils.loadResource("web-agent-templates/LP_visit_info_row_link.html");
        var textInjection = {
            title: rowData.value,
            href: rowData.value,
            target: '_blank'
        };
        var linkValue = this.injectTextDefaults(linkTemplate, textInjection);
        dataToRender.link =  WebAgentUtils.sanitizeText(linkValue || "").text;
        dataToRender.valueTooltip = rowData.value;
        return dataToRender;
    },
    icon : function (rowData) {
        var dataToRender = this.getDefaultRowObject(rowData.rowData || rowData);
        dataToRender.type = this.LPInfoLineType.INFO_ICON;
        dataToRender.labelTitle = rowData.title;
        dataToRender.labelTitleTooltip = rowData.titleTooltip || rowData.title;
        dataToRender.value = rowData.value;
        dataToRender.valueTooltip = rowData.valueTooltip || rowData.value;
        var iconTemplate = require('web-agent-templates/LP_visit_info_row_icon.html');
            // var iconTemplate =lpUtils.loadResource('web-agent-templates/LP_visit_info_row_icon.html');
        var textInjection = {
            iconType: rowData.iconType,
            iconState: rowData.iconState
        };
        dataToRender.icon =  this.injectTextDefaults(iconTemplate, textInjection);
        return dataToRender;
    },
    noTitle : function (rowData) {
        var dataToRender = this.getDefaultRowObject(rowData);
        dataToRender.type = this.LPInfoLineType.NO_TITLE;
        dataToRender.value = WebAgentUtils.sanitizeText(rowData.value || "").text;
        dataToRender.valueTooltip = rowData.valueTooltip || dataToRender.value;
        return dataToRender;
    },
botTopics : function (rowData) {
        var dataToRender = this.getDefaultRowObject(rowData);
        dataToRender.type = this.LPInfoLineType.NO_TITLE;
        var botTopicsTemplate = require('web-agent-templates/LP_visit_info_row_bot_topics.tmpl.html');
        dataToRender.generic = _.template(botTopicsTemplate ,{
            summarySections : rowData.value.sectionsArray || []
        });
        dataToRender.valueTooltip = this.translate('bot_escalation_visitor_info_topics');
        return dataToRender;
    },
    visitorError: function (rowData) {
        var dataToRender = this.getDefaultRowObject(rowData);
        dataToRender.type = this.LPInfoLineType.NO_TITLE_WIDE;
        dataToRender.valueTooltip = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_visitorError");

        var visitorErrorTemplate = require('web-agent-templates/LP_visit_info_row_visitor_error.tmpl.html');


        var data = {
            message: rowData.message || '',
            messageLabel: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_message"),
            code: rowData.code || '',
            codeLabel: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_code"),
            level: rowData.level || '',
            levelLabel: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_level"),
            resolved: rowData.resolved || '',
            resolvedLabel: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_resolved"),
            contextId: rowData.contextId || '',
            contextIdLabel: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_contextId"),

            // remove after deprecation
            messageTooltip: rowData.messageTooltip || '',
            codeTooltip: rowData.codeTooltip || '',
            levelTooltip: rowData.levelTooltip || '',
            resolvedTooltip: rowData.resolvedTooltip || '',
            contextIdTooltip: rowData.contextIdTooltip || ''
        };
        if (typeof rowData.resolved === 'boolean') {
            data.resolved = rowData.resolved === true ? 'True' : 'False';
        }

        dataToRender.generic = _.template(visitorErrorTemplate, data);
        return dataToRender;
    }};

    VisitInfoBase.prototype.getDefaultRowObject = function (rowData) {
        return {
            rowData : rowData,
            type: '',
            labelTitle: '',
            labelTitleTooltip: '',
            labelDetails: '',
            labelDetailsTooltip: '',
            labelExtraDetails: '',
            labelExtraDetailsTooltip: '',
            value: '',
            unescapedValue:'',
            unescapedTooltip:'',
            valueTooltip: '',
            link: '',
            icon: '',
            arrayValue: '',
        generic: ''};
    };

    VisitInfoBase.prototype.participantTagChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.color) {
            this.removeClass(this.LPViewMap.widgetWrapper, this.color);
        }
        this.color = data.newValue;
        this.addClass(this.LPViewMap.widgetWrapper, this.color);
    };

    VisitInfoBase.prototype.toggleRow = function (data, categoryView) {
        var titleView = this.getFirstElement(this.LPViewMap.rowWrapper, categoryView);

        if (titleView) {
            if ((' ' + titleView.className + ' ').indexOf(' ' + this.LPPrefixMap.openState + ' ') === -1) {
                this.addClass(titleView, this.LPPrefixMap.openState);
                this.toggleRowsState[data.rowData.id] = true;
            }
            else {
                this.removeClass(titleView, this.LPPrefixMap.openState);
                this.toggleRowsState[data.rowData.id] = false;
            }
        }
    };

    return VisitInfoBase;

});
